import { render } from "./PlanosDeTreinoLista.vue?vue&type=template&id=ad930a88"
import script from "./PlanosDeTreinoLista.vue?vue&type=script&lang=js"
export * from "./PlanosDeTreinoLista.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__